import useFeatureModels from "ai-management/feature-models/hooks/useFeatureModels";
const useLlmFeatures = () => {
  const { data: featureModels, isLoading } = useFeatureModels();
  return {
    data: featureModels.map(({ feature_id, display_name }) => ({ id: feature_id, title: display_name })),
    isLoading
  };
};
export default useLlmFeatures;
